import {
  NoDataComponent,
  PageWrapper,
  SimpleTableLoadingSkeleton,
  STATUSPAGE,
  TableVirtualized,
} from '@repo/ui';
import { HandleStudentsWithoutRegisteringApp } from 'domain/usecases';
import { TYPE_REPORT } from 'domain/value-objects/type-report';
import { useFormik } from 'formik';
import { ReportsGeneralFilters } from 'presentation/app/modules/Reports/components/reports-general-filters';
import { useStudentsWithoutRegisteringApp } from 'presentation/app/modules/Reports/hooks/useStudentsWithoutRegisteringApp';
import { useAppSelector } from 'presentation/config/hooks/useRedux';
import { Card, Button, Spinner } from 'reactstrap';
import * as Yup from 'yup';

import { makeStudentsWithoutRegisteringAppColumns } from '../../../common/columns/students/students-withou-registering-app-columns';

const StudentsWithoutRegisteringApp = () => {
  const { studentsWithoutRegisteringApp } = useAppSelector(
    (state) => state.studentsWithoutRegisteringApp,
  );

  const {
    loading,
    hasFetchedData,
    selectedSubmitBtn,
    setSelectedSubmitBtn,
    requestHandleStudentsWithoutRegisteringApp,
    requestHandleStudentsWithoutRegisteringAppJson,
  } = useStudentsWithoutRegisteringApp();

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      unit: null,
      groups: [],
      entity: null,
      course: null,
      semester: null,
    },

    validationSchema: Yup.object({
      entity: Yup.object()
        .shape({
          label: Yup.string(),
          value: Yup.string(),
        })
        .nullable(),
      course: Yup.object()
        .shape({
          label: Yup.string(),
          value: Yup.string(),
        })
        .nullable(),
      semester: Yup.object()
        .shape({
          label: Yup.string(),
          value: Yup.string(),
        })
        .nullable(),
      unit: Yup.object()
        .shape({
          label: Yup.string(),
          value: Yup.string(),
        })
        .nullable(),
      groups: Yup.array().of(
        Yup.object()
          .shape({
            label: Yup.string(),
            value: Yup.string(),
          })
          .nullable(),
      ),
    }),

    onSubmit: (values) => {
      const valuesToSubmit: Omit<
        HandleStudentsWithoutRegisteringApp.Params,
        'type'
      > = {
        entity: values.entity?.value,
        course: values.course?.value,
        semester: values.semester?.value,
        curricularUnit: values.unit?.value,
        groups: values.groups.map((group) => group.value),
      };
      switch (selectedSubmitBtn) {
        case 'export-pdf':
          requestHandleStudentsWithoutRegisteringApp({
            ...valuesToSubmit,
            type: TYPE_REPORT.PDF,
          });
          break;
        case 'export-excel':
          requestHandleStudentsWithoutRegisteringApp({
            ...valuesToSubmit,
            type: TYPE_REPORT.EXCEL,
          });
          break;
        case 'export-json':
          requestHandleStudentsWithoutRegisteringAppJson({
            ...valuesToSubmit,
            type: TYPE_REPORT.JSON,
          });
          break;
        default:
          break;
      }
    },
  });

  return (
    <PageWrapper title={`Estudantes sem Cadastros no App`}>
      <h4 className="mb-4">Estudantes sem Cadastros no App</h4>
      <Card>
        <ReportsGeneralFilters
          validation={validation}
          buttonsChildren={
            <div className="d-flex gap-2 justify-content-end align-content-end">
              <Button
                onClick={() => {
                  setSelectedSubmitBtn('export-json');
                }}
                color="primary"
                type="submit"
                id="export-json"
                disabled={Boolean(loading)}
              >
                {selectedSubmitBtn === 'export-json' && Boolean(loading) ? (
                  <Spinner size="sm">{['Carregando...']}</Spinner>
                ) : (
                  <>
                    Visualizar
                    <i className="ri-computer-line mx-2"></i>
                  </>
                )}
              </Button>
              <Button
                onClick={() => {
                  setSelectedSubmitBtn('export-pdf');
                }}
                color="primary"
                type="submit"
                className="btn btn-light waves-effect waves-light"
                id={'save_button'}
                disabled={Boolean(loading)}
              >
                {selectedSubmitBtn === 'export-pdf' && Boolean(loading) ? (
                  <Spinner size="sm">{['Carregando...']}</Spinner>
                ) : (
                  <>
                    Exportar para PDF
                    <i className="las la-file-pdf mx-2"></i>
                  </>
                )}
              </Button>
              <Button
                onClick={() => {
                  setSelectedSubmitBtn('export-excel');
                }}
                color="primary"
                type="submit"
                id={'save_button'}
                className="btn btn-light waves-effect waves-light"
                disabled={Boolean(loading)}
              >
                {selectedSubmitBtn === 'export-excel' && Boolean(loading) ? (
                  <Spinner size="sm">{['Carregando...']}</Spinner>
                ) : (
                  <>
                    Exportar para Excel
                    <i className="ms-2 ri-file-excel-2-line"></i>
                  </>
                )}
              </Button>
            </div>
          }
        />
        {studentsWithoutRegisteringApp?.length === 0 &&
          hasFetchedData &&
          loading === STATUSPAGE.DONE && (
            <div className="p-4">
              <NoDataComponent />
            </div>
          )}

        {loading === STATUSPAGE.LOADING && <SimpleTableLoadingSkeleton />}

        {loading === STATUSPAGE.DONE &&
          studentsWithoutRegisteringApp?.length > 0 && (
            <TableVirtualized
              columns={makeStudentsWithoutRegisteringAppColumns()}
              data={studentsWithoutRegisteringApp}
            />
          )}
      </Card>
    </PageWrapper>
  );
};

export default StudentsWithoutRegisteringApp;
